export default __webpack_public_path__ + "static/media/12.82b74fd7.jpg";